import { semanticColors } from './colors';
import { spacing } from './spacing';

export const layoutTokens = {
  sidebarWidth: 280,
  sidebarCollapsedWidth: 76,
  headerHeight: 64,
  pageMaxWidth: 1600,
  pagePadding: spacing[32] - 4, // 28 — matches AppShellMain
  pagePaddingMobile: spacing[16],
  sectionGap: spacing[24],
  cardGap: spacing[16],
  cardRadius: 12,
  tableRadius: 12,
  pageBackground: semanticColors.canvas,
} as const;
